import * as d3 from 'd3'
import httpManager from "../../util/common"
import { reportYear } from '../../util/util'
import citic_code from '../../../static/json/citic_code.json'
export default {
    props: ['oaid'],
    data() {
        return {
            report_year: null,
            line_data: [],
            cover_year: 1,
            cover_year_options: [1, 2, 3],
            empty_data_box_show: false,
            national_industry_options: null,
            gics_options: null,
            citic_options: citic_code,
            national_industry: '',
            gics: '',
            citic: '',
            national_industry_name: '',
            gics_name: '',
            citic_name: '',
            loading: false
        }

    },
    created() {
        this.setDate()
    },
    methods: {
        setDate() {
            let date = new Date
            let current_year = date.getFullYear()
            const current_month = date.getMonth()
            this.report_year = current_month <= 2 ? current_year - 2 : current_year - 1
          },
        async getCarbonData() {
            let self = this
            self.line_data = []
            self.loading = true
            let params = new Map()
            let years  = self.report_year + ''
            for (let i = 1; i < 4; i++) {
                const currentYear = self.report_year - i
                years = currentYear + ',' + years
            }
            params.set("lang", this.$i18n.locale)
            params.set("oaid", self.oaid)
            params.set('years', years)
            await httpManager('carbon', params)
                .then(res => {
                    if (res.data.data && res.data.data.length > 0) {
                        const { data } = res.data
                        data.forEach(item => {
                            const { 
                                year,
                                carbon_intensity,
                                industry_national_median,
                                gics_median,
                                citic_median,
                                industry_national,
                                gics,
                                citic
                            } = item
                            let obj = {
                                report_year: year,
                                type: 'carbon_intensity',
                                value: carbon_intensity,
                            }
                            let obj1 = {
                                report_year: year,
                                type: 'industry_national_median',
                                value: industry_national_median
                            }
                            let obj2 = {
                                report_year: year,
                                type: 'gics_median',
                                value: gics_median
                            }
                            let obj3 = {
                                report_year: year,
                                type: 'citic_median',
                                value: citic_median
                            }
                            self.line_data.push(obj)
                            self.line_data.push(obj1)
                            self.line_data.push(obj2)
                            self.line_data.push(obj3)
                            if (!self.national_industry)
                                self.national_industry = industry_national
                            if (!self.gics)
                                self.gics = gics
                            if (!self.citic)
                                self.citic = citic
                        });
                    }
                }).catch(error => {
                    console.log(error)
                })
        },
        // 将得到的柱状图数据行业对应的代码转为相应的行业名称
        transCodeToName() {
            // 处理国民经济行业
            let length = this.national_industry_options.length

            if(this.national_industry){
                if(this.national_industry.length == 2){ // 出现如B7这样的数据转为B07
                    this.national_industry = this.national_industry[0] + '0' + this.national_industry[1]
                }
                for (let i = 0; i < length; i++) {
                    let value_length = this.national_industry_options[i].value.length
                    if (this.national_industry.substring(0, value_length) == this.national_industry_options[i].value) {
                        for (let j in this.national_industry_options[i].children) {
                            if (this.national_industry_options[i].children[j].value == this.national_industry) {
                                this.national_industry_name = this.national_industry_options[i].children[j].label
                                break
                            }
                        }
                        break
                    }
                }
            }else {
                this.national_industry_name = ''
            }

            // 处理gics行业
            if(this.gics){
                let gics = this.gics
                for (let i in this.gics_options) {
                    if(this.gics_options[i].industry_group_code == gics) {
                        this.gics_name = this.gics_options[i].industry_group
                        break
                    }
                }
            } else {
                this.gics_name = ''
            }

            // 处理中信行业
            if(this.citic)
                this.citic_name = this.citic_options[this.citic]
            else {
                this.citic_name = ''
            }
        },
        // 国民经济行业代码转为名称
        getNationalIndustry() {
            let promises = []
            let promise1  = reportYear.national_economic("nei_code").then(result => {
                this.national_industry_options = result
            })
            let promise2 = httpManager('gics').then(response => {
                this.gics_options = response.data.data
            })
            promises.push(promise1)
            promises.push(promise2)
            return promises
        },
        drawBarChart(data, {
            x = (d, i) => d.xLabel_1,
            y = d => d.value,
            z = d => d.xLabel_2,
            title,
            marginTop = 30,
            marginRight = 10,
            marginBottom = 30,
            marginLeft = 40,
            width = 640,
            height = 400,
            xPadding = 0.1,
            zPadding = 0.05,
            yLabel,
            yFormat,
            colors = d3.schemeTableau10,
            fontsize = 10
        } = {}) {
            if(!data||data.length<1) {
                this.empty_data_box_show = true
            } else {
                this.empty_data_box_show = true
                data.forEach(element => {
                    if(element.value && element.value > 0)
                        this.empty_data_box_show = false
                })
            }
            const X = d3.map(data, x)
            const Y = d3.map(data, y)
            const Z = d3.map(data, z)
            const xRange = [marginLeft, width - marginRight] // 横坐标的长度范围
            const xType = d3.scaleBand // 横坐标类型
            const yType = d3.scaleLinear // 纵坐标类型
            const yRange = [height - marginBottom, marginTop] // 纵坐标的长度范围

            var xDomain = X  // 横坐标的值域
            var yDomain = [0, d3.max(Y)]    //纵坐标的值域
            var zDomain = Z

            const I = d3.range(X.length)

            const xScale = xType(xDomain, xRange).padding(xPadding)
            let scale_x = X.length / 4
            const xzScale = d3.scaleBand(zDomain, [xScale.bandwidth() / 2 - xScale.bandwidth() /12*scale_x, xScale.bandwidth() / 2 + xScale.bandwidth() /12*scale_x]).padding(zPadding)
            const yScale = yType(yDomain, yRange)
            const zScale = d3.scaleOrdinal(zDomain, colors)
            const xAxis = d3.axisBottom(xScale).tickSizeOuter(0)
            const yAxis = d3.axisLeft(yScale).ticks(height / 60, yFormat)

            if (title === undefined) {
                const formatValue = yScale.tickFormat(100, yFormat);
                title = i => `${X[i]}\n${Z[i]}\n${formatValue(Y[i])}`;
            } else {
                const O = d3.map(data, d => d);
                const T = title;
                title = i => T(O[i], i, data);
            }

            const svg = d3.select("#cd-line-chart-svg").append("svg")
                // .attr("width", width)
                // .attr("heigt", height)
                .attr("viewBox", [0, 0, width, height]) // 添加viewBox后不会自适应缩放
                // .attr("style", `width: ${width}px; height: ${height}px; height: intrinsic;`)// 让svg与其父盒子等大

            const yLine = svg.append("g")
                .attr("transform", `translate(${marginLeft},0)`)
                .call(yAxis)
                .attr("font-size", fontsize)
                .call(g => g.select(".domain").remove())
                .call(g => g.selectAll(".tick line").clone()
                    .attr("x2", width - marginLeft - marginRight)
                    .attr("stroke-opacity", 0.1))
                .call(g => g.append("text")
                    .attr("x", -marginLeft)
                    .attr("y", 10)
                    .attr("fill", "currentColor")
                    .attr("text-anchor", "start")
                    .text(yLabel))

            const xLine = svg.append("g")
                .attr("transform", `translate(0,${height - marginBottom})`)
                .call(xAxis)
                .attr("font-size", fontsize)
            const bar = svg.append("g")
                .selectAll("rect")
                .data(I)
                .join("rect")
                .attr("x", i => xScale(X[i]) + xzScale(Z[i]))
                .attr("y", i => yScale(Y[i]))
                .attr("width", xzScale.bandwidth())
                .attr("height", i => yScale(0) - yScale(Y[i]))
                .attr("fill", i => zScale(Z[i]));

            // return svg.node()

        }
    },
    async mounted() {
        let promises = []
        let industry_data_promises = this.getNationalIndustry()
        industry_data_promises.forEach(promise => {
            promises.push(promise)
        })
        await this.getCarbonData()
        await Promise.all(promises)
        this.loading = false
        let width = 800/20*getComputedStyle(window.document.documentElement)['font-size'].slice(0, 2)
        let height = 380/20*getComputedStyle(window.document.documentElement)['font-size'].slice(0, 2)
        let barSet = {
            x: d => d.report_year, // 横坐标为report_year
            y: d => d.value,    // 纵坐标为value
            z: d => d.type,     // 二级横坐标为type，该参数识别矩形的颜色
            marginBottom: 100,
            marginLeft: 60,
            colors: ['#6d5de1', '#e1b93c', '#4c964b', '#4563b3'],
            width: width,
            height: height,
            fontsize: 14
        }
        this.line_data.sort((a,b) => a.report_year - b.report_year)
        this.drawBarChart(this.line_data, barSet)
            this.transCodeToName()
    },
    computed: {
        legends() {
            return [
                { name: this.$t('carbon.company_GHG_emission_intensity'), color: '#6d5de1' },
                { name: this.national_industry_name + this.$t('carbon.industry_median_GHG_intensity_national_economy'), color: '#e1b93c' },
                { name: this.gics_name + this.$t('carbon.industry_median_GHG_intensity_gics'), color: '#4c964b' },
                { name: this.citic_name + this.$t('carbon.industry_median_GHG_intensity_citic'), color: '#4563b3' },
            ]
        }
    }
}



// WEBPACK FOOTER //
// ./src/carbon/js/cd_bar_chart.js